// components/admin/AdminLogin.jsx
import { useState } from "react";
import { Lock, Mail } from "lucide-react";

export default function AdminLogin() {
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await fetch(`${process.env.REACT_APP_API_URL}myadmin/login`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form)
    });
    const data = await res.json();
    if (data.success) {
      localStorage.setItem("token", data.token);
      window.location.href = "/myadmindashboard";
    } else {
      alert(data.message || "Login failed");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 to-pink-600 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-10 w-full max-w-md">
        <h1 className="text-4xl font-bold text-center text-purple-700 mb-8">Admin Login 🔐</h1>
        <form onSubmit={handleLogin} className="space-y-6">
          <div>
            <label className="flex items-center gap-3 text-lg font-medium">
              <Mail /> Email
            </label>
            <input
              type="email"
              className="mt-2 w-full px-4 py-4 border rounded-lg focus:ring-4 focus:ring-purple-300"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              required
            />
          </div>
          <div>
            <label className="flex items-center gap-3 text-lg font-medium">
              <Lock /> Password
            </label>
            <input
              type="password"
              className="mt-2 w-full px-4 py-4 border rounded-lg focus:ring-4 focus:ring-purple-300"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
              required
            />
          </div>
          <button
            type="submit"
            disabled={loading}
            className="w-full bg-purple-600 text-white py-5 rounded-lg font-bold text-xl hover:bg-purple-700"
          >
            {loading ? "Logging in..." : "Enter Dashboard"}
          </button>
        </form>
      </div>
    </div>
  );
}